export default function MeetTheGuide() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
            <div className="w-full md:w-2/5">
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/882f4bb03f02a5ca5921ba745ccef79f.png"
                  alt="A warm approachable woman in her late forties with a soft genuine smile, seated in a calm home office with natural daylight"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="w-full md:w-3/5">
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-6">
                Nobody Sees What Happens When You Get Home
              </h2>

              <div className="space-y-3 mb-6">
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  Everyone sees the professional.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The parent.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The business owner.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The person who always seems to have everything together.
                </p>
              </div>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                What they don&rsquo;t see is the quiet battle that begins each evening.
              </p>

              <div className="space-y-2 mb-4">
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The drink you promise will only be one.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The bottle you hope nobody notices.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  The guilt that follows.
                </p>
              </div>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                If you&rsquo;re quietly struggling with alcohol and don&rsquo;t want anyone to know, you&rsquo;ve found a safe place to begin.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Serena&rsquo;s Quiet Recovery Space is a private online recovery programme designed for people who value their privacy and want to understand why alcohol has become part of their life.
              </p>

              <div className="space-y-2 mb-4">
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  Here, there are no public meetings.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  No labels.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  No judgement.
                </p>
              </div>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Just practical guidance, compassionate support and a confidential place to begin changing your relationship with alcohol&mdash;at your own pace.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed italic">
                Because lasting change begins with understanding. Not shame.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}